import {
  OPEN_AI_CHAT,
  CLOSE_AI_CHAT,
  TOGGLE_AI_CHAT,
  OPEN_AI_CHAT_WITH_CONTEXT,
  CLEAR_AI_CHAT_CONTEXT,
  SET_AI_CHAT_PREDEFINED_PROMPT,
  CLEAR_AI_CHAT_PREDEFINED_PROMPT,
  OPEN_AI_CHAT_WITH_HELP_CENTER_URL,
  CLEAR_AI_CHAT_HELP_CENTER_URL,
  AIChatActionTypes,
  WsMemberSelectedContext,
} from "./aiChatTypes";

export const openAIChat = (): AIChatActionTypes => ({
  type: OPEN_AI_CHAT,
});

export const closeAIChat = (): AIChatActionTypes => ({
  type: CLOSE_AI_CHAT,
});

export const toggleAIChat = (): AIChatActionTypes => ({
  type: TOGGLE_AI_CHAT,
});

export const openAIChatWithContext = (
  wsMemberSelectedContext: WsMemberSelectedContext,
): AIChatActionTypes => {
  return {
    type: OPEN_AI_CHAT_WITH_CONTEXT,
    payload: {
      wsMemberSelectedContext,
    },
  };
};

export const clearAIChatContext = (): AIChatActionTypes => ({
  type: CLEAR_AI_CHAT_CONTEXT,
});

export const setAIChatPredefinedPrompt = (
  chatInput: string,
  predefinedPrompt: string,
): AIChatActionTypes => ({
  type: SET_AI_CHAT_PREDEFINED_PROMPT,
  payload: { chatInput, predefinedPrompt },
});

export const clearAIChatPredefinedPrompt = (): AIChatActionTypes => ({
  type: CLEAR_AI_CHAT_PREDEFINED_PROMPT,
});

export const openAIChatWithHelpCenterUrl = (
  helpCenterUrl: string,
): AIChatActionTypes => ({
  type: OPEN_AI_CHAT_WITH_HELP_CENTER_URL,
  payload: { helpCenterUrl },
});

export const clearAIChatHelpCenterUrl = (): AIChatActionTypes => ({
  type: CLEAR_AI_CHAT_HELP_CENTER_URL,
});
